import { createContext, useContext } from 'react';
import { defaultTheme } from './defaultTheme';
import { jsx as _jsx } from "react/jsx-runtime";
const ThemeContext = /*#__PURE__*/createContext(defaultTheme);
export const ThemeProvider = ({
  theme = defaultTheme,
  children
}) => /*#__PURE__*/_jsx(ThemeContext.Provider, {
  value: theme,
  children: children
});
export const useTheme = () => useContext(ThemeContext);